import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LabelValueInterface } from '@app/shared/types/types';
import { DatePeriod } from '@app/shared/components/date-presets-selector/interfaces/date-presets-selector.interface';

@Component({
  selector: 'date-presets-selector',
  templateUrl: './date-presets-selector.component.html',
  styleUrls: ['./date-presets-selector.component.scss'],
})
export class DatePresetsSelectorComponent {

  @Input() selectedPeriod: DatePeriod = DatePeriod.LAST_30_DAYS;
  @Input() outlined = false;
  @Output() changePeriod: EventEmitter<DatePeriod> = new EventEmitter<DatePeriod>();

  public presetsDropdownOptions: LabelValueInterface<DatePeriod>[] = [
    {
      label: 'datePresetsSelector.thisWeek',
      value: DatePeriod.THIS_WEEK,
    },
    {
      label: 'datePresetsSelector.lastWeek',
      value: DatePeriod.LAST_WEEK,
    },
    {
      label: 'datePresetsSelector.last30days',
      value: DatePeriod.LAST_30_DAYS,
    },
    {
      label: 'datePresetsSelector.thisMonth',
      value: DatePeriod.THIS_MONTH,
    },
    {
      label: 'datePresetsSelector.lastMonth',
      value: DatePeriod.LAST_MONTH,
    },
    {
      label: 'datePresetsSelector.rolling12months',
      value: DatePeriod.ROLLING_12_MONTHS,
    },
    {
      label: 'datePresetsSelector.thisYear',
      value: DatePeriod.THIS_YEAR,
    },
  ];

  public onChangePeriod(): void {
    this.changePeriod.emit(this.selectedPeriod);
  }
}
